import React, { useState } from 'react';
import { CharacterSlot, getCharacterFallbacks, normalizeCharacterTheme } from '../../config/characterThemeAssets.mjs';

interface Props { theme?: unknown; slot: CharacterSlot; className?: string; alt?: string; }

function ImageSequence({ theme, slot, className, alt = '' }: Props) {
  const [attempt, setAttempt] = useState(0);
  const paths = getCharacterFallbacks(theme, slot);
  if (attempt >= paths.length) return null;
  return <img src={paths[attempt]} alt={alt} className={className} onError={() => {
    if (attempt + 1 === paths.length) console.warn('[character-image] 캐릭터 이미지를 찾을 수 없습니다.', { theme: normalizeCharacterTheme(theme), slot });
    setAttempt(attempt + 1);
  }} />;
}

export default function CharacterImage(props: Props) {
  return <ImageSequence key={`${normalizeCharacterTheme(props.theme)}:${props.slot}`} {...props} />;
}
